<script setup lang="ts">
import { useSettingsStore } from '@/stores/settings';
import { ref, watch, onMounted } from 'vue';

definePageMeta({
  layout: 'default',
  middleware: ['refresh-ip', 'require-verification', 'cookie-consent']
});

const settingsStore = useSettingsStore();
const settings = settingsStore.settings;
const isLoading = ref(true);

let sportsBookType = settings.sport_sportbook_type;

const phrases = [
  'Carregando esportes',
  'Aguarde um momento',
  'Quase lá',
  'Carregando...',
  'Buscando as melhores odds'
];
const currentPhrase = ref('Carregando esportes');


const updatePhrase = () => {
  const randomIndex = Math.floor(Math.random() * phrases.length);
  currentPhrase.value = phrases[randomIndex];
};

const handleError = () => {
  reloadNuxtApp({ force: true });
};

onMounted(() => {
  let interval = setInterval(updatePhrase, 2500);

  watch(isLoading, (value) => {
    if (value === false) {
      clearInterval(interval);
    }
  });
});

</script>

<template>
  <div
    class="relative min-h-[95dvh] flex flex-col w-full select-none items-center justify-center bg-brand-background"
  >
  <LegitimuzElements />

    <template v-if="settings.sport_enabled">
      <div v-show="!isLoading" class="w-full">
        <client-only>
          <SportFrame
            @isLoading="(value) => (isLoading = value)"
            v-if="sportsBookType === 'digitain'"
          />
          <AltenarFrame
            @isLoading="(value) => (isLoading = value)"
            v-else-if="sportsBookType === 'altenar'"
          />
          <div v-else class="flex flex-col items-center justify-center gap-4 p-8">
            <p class="opacity-70 max-w-72 text-center">
              Encontramos um problema ao carregar os jogos.
            </p>
            <BaseButton variant="secondary" @click="handleError" icon="fa6-solid:rotate-right">
              Tentar Novamente
            </BaseButton>
          </div>
        </client-only>
      </div>

      <transition name="fade">
        <div
          v-show="isLoading"
          class="absolute bg-brand-background top-0 left-0 h-[95dvh] w-full flex items-center justify-center flex-col"
        >
          <BaseLogo class="max-w-32 !h-fit animate-pulse" />

          <div
            class="flex flex-col items-center gap-4 animate-pulse transition-all mt-6 z-50 relative"
          >
            <BaseSpinner class="max-w-6" />
            <div class="overflow-none">
              <transition name="fade" mode="out-in">
                <p class="text-gray-500 text-sm lg:text-base text-nowrap" :key="currentPhrase">
                  {{ currentPhrase }}
                </p>
              </transition>
            </div>
          </div>
        </div>
      </transition>
    </template>

    <template v-if="!settings.sport_enabled">
      <div class="flex">
        <h2 class="mx-auto mt-5 font-bold">Jogos em manutenção</h2>
      </div>
    </template>
  </div>
</template>